import { NotificationType } from './notification-type';

export const NOTIFICATION_TOPIC_INTERNAL = '1/2/3/4/5/6/HEJ';

/**
 * Notification partial solace topic names mapped to type.
 * If you want to get the topic back later, you need to provide a full name.
 */
export const NOTIFICATION_SOLACE_TOPICS = new Map<string, NotificationType>(Object.entries({
  'ingka.myidentity.sys': NotificationType.IAM,
  'ingka.org/appointment': NotificationType.Boka,
  'ingka.hej.sys/weeklysales/full/goalreached/v1/{region}/HEJ/ingka': NotificationType.SalesIndex,
  'ingka.hej.sys/happycustomer/full/goalreached/v1/{region}/HEJ/ingka': NotificationType.HappyCustomer,
  'ingka.mia.sys': NotificationType.MIA,
  'ingka.people.pdi/AA/notification/subscribe/V1/{region}/PDITOI': NotificationType.Stay,

  // special case for iObserve
  'ingka.csh.sys/notification/full/created/V1/ALL/CSH': ('iobserve' as any),

  // Debug - change type to match `rest/notification-iam.txt`
  [NOTIFICATION_TOPIC_INTERNAL]: NotificationType.INTERNAL,
}));
